import { EventEmitter } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { DateConstants } from "../../constants/date.constants";
import { DatePipe } from "@angular/common";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
var POSSummaryReportsComponent = /** @class */ (function () {
    function POSSummaryReportsComponent(_translateService, _customerservice, _datePipe, _reportService, _commonService, distributorFormatPipe, _currencyPipe) {
        this._translateService = _translateService;
        this._customerservice = _customerservice;
        this._datePipe = _datePipe;
        this._reportService = _reportService;
        this._commonService = _commonService;
        this.distributorFormatPipe = distributorFormatPipe;
        this._currencyPipe = _currencyPipe;
        this.paymentMethods = [];
        this.isLoadedData = new EventEmitter();
        this.addFavoriteEvent = new EventEmitter();
        this.pageSizes = [50, 100, 150, 200];
        this.pageNumber = 1;
        this.pageSize = 50;
        this.pageCount = 0;
        this.currentDate = new Date();
        this.excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
        this.printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
        this.reportsSummary = null;
        this.allReportsSummary = null;
        this.isResponseError = false;
        this.isLoading = false;
        this.isAllReportsSummaryLoading = false;
    }
    POSSummaryReportsComponent.prototype.ngOnInit = function () {
        // this.getPOSOrderSummaryReport();
        // this.setColGroupWidth(); 
        this.exportFile('csv');
    };
    /**
     * To Set the col group width for table
     */
    POSSummaryReportsComponent.prototype.setColGroupWidth = function () {
        this.colGroupWidth = this.paymentMethods.length ? (100 / (this.paymentMethods.length + 6)) + '%' : (100 / 6) + '%';
        this.headerLength = this.paymentMethods.length ? (this.paymentMethods.length + 6) : 6;
    };
    /**
     * To get POS order summary report
     * @returns void
     */
    POSSummaryReportsComponent.prototype.getPOSOrderSummaryReport = function () {
        var _this = this;
        this.isLoading = true;
        this._reportService.getPOSOrderSummaryReport(this.posLocationId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, false, this.notesRequired).subscribe(function (response) {
            if (response) {
                _this.reportsSummary = response;
                _this.isLoading = false;
                _this.isResponseError = false;
                _this.pageCount = response.posOrderCount;
                _this.isLoadedData.emit(true);
            }
            else {
                _this.setDefaultValues();
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            _this.setDefaultValues();
        });
    };
    /**
     * To Set Default Values
     */
    POSSummaryReportsComponent.prototype.setDefaultValues = function () {
        this.reportsSummary = null;
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    };
    /**
     * To load product sales report
     * @returns void
     */
    POSSummaryReportsComponent.prototype.loadPOSSummaryReports = function () {
        this.getPOSOrderSummaryReport();
    };
    /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    POSSummaryReportsComponent.prototype.pageSizeChange = function (pageSize) {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getPOSOrderSummaryReport();
        }
    };
    /**
     * To change page number
     * @param  {number} pageNumber
     */
    POSSummaryReportsComponent.prototype.pageChange = function (pageNumber) {
        this.pageNumber = pageNumber;
        this.getPOSOrderSummaryReport();
    };
    /**
     * To emit add favorite event to parent component
     * @returns void
     */
    POSSummaryReportsComponent.prototype.addToFavorite = function () {
        this.addFavoriteEvent.emit(true);
    };
    /**
     * To Export The file
     */
    POSSummaryReportsComponent.prototype.exportFile = function (type) {
        // if (this.allReportsSummary && this.allReportsSummary.posOrderModel && this.allReportsSummary.posOrderModel.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllReportSummaryReports(type);
        // }
        this.fetchAllReportSummaryReports(type);
    };
    /**
     * To Fetch all report summary data from service
     */
    POSSummaryReportsComponent.prototype.fetchAllReportSummaryReports = function (type) {
        var _this = this;
        this.isLoading = true;
        this.isAllReportsSummaryLoading = true;
        this._reportService.getPOSOrderSummaryReport(this.posLocationId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, true, this.notesRequired).subscribe(function (response) {
            if (response) {
                _this.isAllReportsSummaryLoading = false;
                _this.allReportsSummary = response;
                _this.isLoading = false;
                _this.isResponseError = false;
                _this.pageCount = response.posOrderCount;
                _this.isLoadedData.emit(true);
                _this.download(type);
            }
            else {
                _this.isAllReportsSummaryLoading = false;
                _this.allReportsSummary = null;
                _this.setDefaultValues();
            }
        }, function (error) {
            var message = _this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            _this._commonService.createNotification('', message.value, NotificationType.ERROR);
            _this.allReportsSummary = null;
            _this.isAllReportsSummaryLoading = false;
            _this.setDefaultValues();
        });
    };
    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    POSSummaryReportsComponent.prototype.download = function (type) {
        var allSummaryReportsLength = this.allReportsSummary && this.allReportsSummary.posOrderModel ?
            this.allReportsSummary && this.allReportsSummary.posOrderModel.length : null;
        if (allSummaryReportsLength > 0) {
            var columns = [
                this._translateService.get('reports.Date/Time')['value'],
                this._translateService.get('reports.ProcessingPeriod')['value'],
                this._translateService.get('reports.Web Order #')['value'],
                this._translateService.get('reports.Order')['value'] + ' #',
                this._translateService.get('reports.Status')['value'],
                this._translateService.get('reports.Member')['value'] + ' #',
                this._translateService.get('reports.Member Name')['value'],
                this._translateService.get('reports.User Name')['value'],
                this._translateService.get('reports.Discount')['value'],
                this._translateService.get('reports.Vat')['value'],
                this._translateService.get('reports.Handling Charge')['value'],
                this._translateService.get('reports.Total Rcvd')['value']
            ];
            var paymentHeaders = [];
            for (var _i = 0, _a = this.paymentMethods; _i < _a.length; _i++) {
                var method = _a[_i];
                var value = this._translateService.get('reports.' + method.paymentMethodName)['value'] ?
                    this._translateService.get('reports.' + method.paymentMethodName)['value'] : method.paymentMethodName;
                paymentHeaders.push(value);
            }
            columns = columns.concat(paymentHeaders);
            columns.push(this._translateService.get('reports.Total')['value']);
            columns.push(this._translateService.get('reports.Notes')['value']);
            var rowdata = new Array();
            var finalrows = new Array();
            var paymentValues = [];
            for (var i = 0; i < allSummaryReportsLength; i++) {
                rowdata = [];
                paymentValues = [];
                var row = this.allReportsSummary.posOrderModel[i];
                var fboId = row.distributorId ? this.distributorFormatPipe.transform(row.distributorId) : '';
                rowdata.push(row.orderPostedDate ? this._datePipe.transform(row.orderPostedDate, DateConstants.DateTimeFormat) : '');
                rowdata.push(row.processingPeriod ? row.processingPeriod : '');
                rowdata.push(row.webOrderID ? row.webOrderID : '');
                rowdata.push(row.orderNumber ? row.orderNumber : '');
                rowdata.push(row.orderStatus ? row.orderStatus : '');
                rowdata.push(fboId);
                rowdata.push(row.memberName ? row.memberName : '');
                rowdata.push(row.userName ? row.userName : '');
                rowdata.push(row.discountAmount ? row.discountAmount : '');
                rowdata.push(row.vatAmount ? row.vatAmount : '');
                rowdata.push(row.handlingCharge ? row.handlingCharge : '');
                rowdata.push(row.totalAmountRcvd ? row.totalAmountRcvd : '');
                for (var _b = 0, _c = this.paymentMethods; _b < _c.length; _b++) {
                    var method = _c[_b];
                    paymentValues.push(row.paymentList && row.paymentList[method.paymentMethodKey] ? this.currenyFormatValue(row.paymentList[method.paymentMethodKey]) : '');
                }
                rowdata = rowdata.concat(paymentValues);
                rowdata.push(row.orderTotal ? this.currenyFormatValue(row.orderTotal) : '');
                rowdata.push(row.paymentNote ? row.paymentNote : '');
                finalrows.push(rowdata);
            }
            if (this.allReportsSummary && this.allReportsSummary.paymentTotal) {
                rowdata = [];
                paymentValues = [];
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push('');
                rowdata.push(this._translateService.get('reports.Total')['value']);
                for (var _d = 0, _e = this.paymentMethods; _d < _e.length; _d++) {
                    var method = _e[_d];
                    paymentValues.push(this.allReportsSummary.paymentTotal[method.paymentMethodKey] ? this.currenyFormatValue(this.allReportsSummary.paymentTotal[method.paymentMethodKey]) : '');
                }
                rowdata = rowdata.concat(paymentValues);
                rowdata.push(this.allReportsSummary.orderTotalSum ? this.currenyFormatValue(this.allReportsSummary.orderTotalSum) : '');
                rowdata.push('');
                finalrows.push(rowdata);
            }
            var title = this._translateService.get('reports.POS Summary Reports From')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === FileUploadConstants.CSV_FILE_EXTENSION) {
                this._customerservice.ExcelDownload(columns, finalrows, 'POS Summary Reports', '', false);
            }
            else if (type === FileUploadConstants.PRINT) {
                this._customerservice.constructTableAndPrint(columns, finalrows, title, true);
            }
        }
    };
    Object.defineProperty(POSSummaryReportsComponent.prototype, "currenyFormatValue", {
        /**
         * To Get Currency Value for the price
         */
        get: function () {
            var _this = this;
            return function (value) {
                if (_this.storeInfo) {
                    value = _this._currencyPipe.getCurrencyFormat(_this.storeInfo, _this.storeInfo.currencyFormatCode, value);
                    return value;
                }
                return value;
            };
        },
        enumerable: true,
        configurable: true
    });
    return POSSummaryReportsComponent;
}());
export { POSSummaryReportsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/pos-summary-reports.component.ts.pre-build-optimizer.js